import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, Whisper, Tooltip, IconButton, Icon, Button, Toggle } from 'rsuite'
import ProgressDataCard from './charts/ProgressDataCard'
import SingleGauge from './charts/SingleGauge'
import DashboradToggle from './DashboradToggle'

export default function ProjectDashboard2({ isSetting, isShow, onSettingChange }) {
  const [isLoading, setIsLoading] = useState(false)
  const [schema, setSchema] = useState()

  useEffect(() => {
    handelGetSchemaDashboard()
  }, [])

  const handelGetSchemaDashboard = async () => {
    setIsLoading(true)
    try {
      // const response = await getUserProfile()
      // setSchema(response)

      // mock schema
      const response = mock
      setSchema(response)
    } catch (e) {
      setError({})
    }
    setIsLoading(false)
  }

  const moreDetail = (data) => {
    return (
      <Tooltip>
        <div style={{ textAlign: 'left', paddingTop: 10 }}>
          <b>{data.label}</b>
          <ul style={{ marginLeft: -20 }}>
            {data.list?.map((item) => (
              <li>{item}</li>
            ))}
          </ul>
        </div>
      </Tooltip>
    )
  }

  const detailButton = (schema) => {
    return (
      <>
        {schema.detail.icon ? (
          <IconButton
            style={{ minWidth: '80%', maxWidth: '100%' }}
            icon={<Icon appearance="ghost" icon={schema.detail.icon} />}
            placement="right"
          >
            {schema.detail.btnLabel}
          </IconButton>
        ) : (
          <Button style={{ minWidth: '80%', maxWidth: '100%' }}>{schema.detail.btnLabel}</Button>
        )}
      </>
    )
  }

  const StepProgress = ({ schema, divideLine }) => (
    <>
      {divideLine && (
        <div
          style={{
            width: '48%',
            border: `10px solid ${schema.color}`,
            marginLeft: '74%',
            marginTop: '90px',
            position: 'absolute',
          }}
        />
      )}

      <div style={{ height: '200px' }}>
        <SingleGauge schema={schema} />
      </div>

      {schema.detail ? (
        <div style={{ marginTop: 10 }}>
          {schema.detail.tooltip ? (
            <Whisper
              //controlId="control-id-active"
              trigger="active"
              placement="bottom"
              speaker={moreDetail(schema.detail)}
            >
              {schema.detail.icon ? (
                <IconButton
                  style={{ minWidth: '80%', maxWidth: '100%' }}
                  icon={<Icon appearance="ghost" icon={schema.detail.icon} />}
                  placement="right"
                >
                  {schema.detail.btnLabel}
                </IconButton>
              ) : (
                <Button style={{ minWidth: '80%', maxWidth: '100%' }}>
                  {schema.detail.btnLabel}
                </Button>
              )}
            </Whisper>
          ) : (
            <>
              {schema.detail.icon ? (
                <IconButton
                  style={{ minWidth: '80%', maxWidth: '100%' }}
                  icon={<Icon appearance="ghost" icon={schema.detail.icon} />}
                  placement="right"
                >
                  {schema.detail.btnLabel}
                </IconButton>
              ) : (
                <Button style={{ minWidth: '80%', maxWidth: '100%' }}>
                  {schema.detail.btnLabel}
                </Button>
              )}
            </>
          )}
        </div>
      ) : (
        <div style={{ marginTop: 10, height: 36 }}></div>
      )}
    </>
  )

  return (
    <>
      {schema && (
        <Panel header="" bordered collapsible defaultExpanded shaded>
          {schema.section1 && (
            <Row style={{ marginTop: 10 }}>
              {isSetting && (
                <DashboradToggle
                  onChange={onSettingChange}
                  dashboradName={schema.section1.name}
                  checked={isShow}
                />
              )}

              {schema.section1.datas.map((item) => {
                return (
                  <Col xs={24} sm={12} md={6} lg={6}>
                    <div style={{ paddingLeft: 10, textAlign: 'center' }}>
                      <b>--- {item.header} ---</b>
                      <ProgressDataCard schema={item.data} />
                    </div>
                  </Col>
                )
              })}
            </Row>
          )}

          {schema.section2 && (
            <Row style={{ marginTop: 20, textAlign: 'center' }}>
              {isSetting && (
                <DashboradToggle
                  onChange={onSettingChange}
                  dashboradName={schema.section2.name}
                  checked={isShow}
                />
              )}
              <Col xs={24} sm={24} md={24} lg={24} align="left">
                <Button style={{ minWidth: '150px' }}>{schema.section2.label}</Button>
              </Col>
              {schema.section2.datas.map((item, index) => {
                return (
                  <Col xs={24} sm={6} md={4} lg={3}>
                    <StepProgress
                      schema={item}
                      divideLine={
                        index < schema.section2.datas.length - 1 && schema.section2.datas.length > 1
                      }
                    />
                  </Col>
                )
              })}
            </Row>
          )}

          {schema.section3 && (
            <Row style={{ marginTop: 20, textAlign: 'center' }}>
              {isSetting && (
                <DashboradToggle
                  onChange={onSettingChange}
                  dashboradName={schema.section3.name}
                  checked={isShow}
                />
              )}
              <Col xs={24} sm={24} md={24} lg={24} align="left">
                <Button style={{ minWidth: '150px' }}>{schema.section3.label}</Button>
              </Col>
              {schema.section3.datas.map((item, index) => {
                return (
                  <Col xs={24} sm={6} md={4} lg={3}>
                    <StepProgress
                      schema={item}
                      divideLine={
                        index < schema.section3.datas.length - 1 && schema.section3.datas.length > 1
                      }
                    />
                  </Col>
                )
              })}
            </Row>
          )}
        </Panel>
      )}
    </>
  )
}

const mock = {
  section1: {
    name: 'section1',
    label: '',
    datas: [
      {
        header: 'จำนวนดำเนินการ',
        data: {
          label: '9999',
          value: 999999999,
          datas: [
            {
              label: 'อนุมัติ',
              value: '80',
              color: '#3ab294',
            },
            {
              label: 'เบิกจ่าย',
              value: '50',
              color: '#ffb980',
            },
          ],
        },
      },
      {
        header: 'จำนวนล่าช้า',
        data: {
          label: '9999',
          value: 999999999,
          datas: [
            {
              label: 'อนุมัติ',
              value: '80',
              color: '#3ab294',
            },
            {
              label: 'เบิกจ่าย',
              value: '50',
              color: '#ffb980',
            },
          ],
        },
      },
      {
        header: 'จำนวนปิด',
        data: {
          label: '9999',
          value: 999999999,
          datas: [
            {
              label: 'อนุมัติ',
              value: '80',
              color: '#3ab294',
            },
            {
              label: 'เบิกจ่าย',
              value: '50',
              color: '#ffb980',
            },
          ],
        },
      },
      {
        header: 'จำนวนทั้งหมด',
        data: {
          label: '9999',
          value: 999999999,
          datas: [
            {
              label: 'อนุมัติ',
              value: '80',
              color: '#3ab294',
            },
            {
              label: 'เบิกจ่าย',
              value: '50',
              color: '#ffb980',
            },
          ],
        },
      },
    ],
  },

  section2: {
    name: 'section2',
    label: 'Upstream',
    datas: [
      {
        name: 'รอรับเรื่อง',
        label: '25',
        value: 80,
        color: '#3ab294',
      },
      {
        name: 'กำลังตรวจสอบ',
        label: '10',
        value: 67,
        color: '#3ab294',
      },
      {
        name: 'ลงทะเบียน',
        label: '60',
        value: 50,
        color: '#3ab294',
      },
      {
        name: 'คัดกรอง',
        label: '200',
        value: 75,
        color: '#3ab294',
      },
      {
        name: 'กลั่นกรอง',
        label: '50',
        value: 50,
        color: '#3ab294',
        detail: {
          icon: 'arrow-down-line',
          btnLabel: 'เพิ่มเติม',
          label: 'สถานะอยู่ที่',
          tooltip: true,
          list: ['สำนัก25', 'เลือกผู้ทรง 25', 'รับผลกลั่นกรอง 20', 'สรุปผล 25'],
        },
      },
      {
        name: 'รออนุมัติ',
        label: '57',
        value: 67,
        color: '#3ab294',
      },
      {
        name: 'อนุมัติ',
        label: '50',
        value: 75,
        color: '#3ab294',
      },
      {
        name: 'อยู่ระหว่างทำข้อตกลง',
        label: '30',
        value: 80,
        color: '#3ab294',
        detail: {
          icon: 'arrow-down-line',
          btnLabel: 'เพิ่มเติม',
          label: 'สถานะอยู่ที่',
          tooltip: true,
          list: ['ศสญ.ส่งข้อเสนอ', 'ภาคี', 'ศสญ.ส่งข้อเสนอ'],
        },
      },
    ],
  },
  section3: {
    name: 'section3',
    label: 'Downstream',
    datas: [
      {
        name: 'ดำเนินการ',
        label: '2000',
        value: 60,
        color: '#f6e187',
        detail: {
          icon: 'arrow-down-line',
          btnLabel: 'เพิ่มเติม',
          label: 'สถานะอยู่ที่',
          tooltip: true,
          list: ['ศสญ.', 'สำนัก 6', 'การเงิน'],
        },
      },
      {
        name: 'ใกล้ถึงกำหนดเบิก (30 วัน)',
        label: '200',
        value: 45,
        color: '#f6e187',
        detail: {
          icon: 'arrow-down-line',
          btnLabel: 'เพิ่มเติม',
          tooltip: true,
          list: ['จม. แจ้งเตือน 4'],
        },
      },
      {
        name: 'รอตรวจสอบ',
        label: '300',
        value: 60,
        color: '#f6e187',
        detail: {
          icon: 'arrow-down-line',
          btnLabel: 'เพิ่มเติม',
          tooltip: true,
          list: ['ส. 1 (e-report)', 'จ. 1 (e-fin)', 'บริหาร คก.ย่อย'],
        },
      },
      {
        name: 'รอปิดโครงการ',
        label: '50',
        value: 75,
        color: '#f6e187',
        detail: {
          icon: 'arrow-down-line',
          btnLabel: 'เพิ่มเติม',
          label: 'สถานะอยู่ที่',
          tooltip: true,
          list: ['สำนัก 25', 'การเงิน 20', 'ศสญ. 8'],
        },
      },
      {
        name: 'เลยกำหนดถึงการเบิก',
        label: '30',
        value: 85,
        color: '#d87a80',
        detail: {
          btnLabel: 'บันทึกการติดตาม',
        },
      },
      {
        name: 'ล่าช้าเกิน 90 วัน',
        label: '3',
        value: 60,
        color: '#d87a80',
        detail: {
          btnLabel: 'บันทึกการติดตาม',
        },
      },
      {
        name: 'รอยุติโครงการ',
        label: '15',
        value: 45,
        color: '#d87a80',
        detail: {
          icon: 'arrow-down-line',
          btnLabel: 'เพิ่มเติม',
          label: 'สถานะอยู่ที่',
          tooltip: true,
          list: ['สำนัก 4', 'กฎหมาย 3', 'ศสญ. 8'],
        },
      },
    ],
  },
}
